// Repairs malformed internal blog links inside article HTML at render time.
// Authors sometimes paste hrefs like "edgely.trade/blog/x", "www.edgely.trade/
// blog/x", or "blog/x" (no leading slash). Browsers resolve these RELATIVE to
// the current /blog/<slug> page, producing /blog/<slug>/edgely.trade/blog/x —
// a soft-404. We normalize any edgely-internal blog reference to an absolute
// path "/blog/...". External links and already-correct links are untouched.

export function fixInternalBlogLinks(html: string): string {
  // Match href="..." or href='...' capturing quote + value.
  return html.replace(/href=(["'])(.*?)\1/gi, (full, quote, value) => {
    const fixed = normalizeHref(value);
    return fixed === value ? full : `href=${quote}${fixed}${quote}`;
  });
}

function normalizeHref(value: string): string {
  const v = value.trim();

  // Already a correct site-absolute path.
  if (v.startsWith("/")) return v;

  // Fully-qualified edgely URL → reduce to path.
  const fq = v.match(/^https?:\/\/(?:www\.)?edgely\.trade(\/.*)?$/i);
  if (fq) return fq[1] || "/";

  // Host-relative without scheme: "edgely.trade/..." or "www.edgely.trade/..."
  const hostRel = v.match(/^(?:www\.)?edgely\.trade(\/.*)?$/i);
  if (hostRel) return hostRel[1] || "/";

  // Bare "blog/..." (missing leading slash) → "/blog/..."
  if (/^blog\//i.test(v)) return "/" + v;

  // Anything else (external, mailto, anchors) untouched.
  return value;
}
